<template>
  <div style="text-align: center">
    <div>
      <h2 class="mb-4">This shop is closed</h2>
    </div>
    <div>
      <img
        src="../../../assets/images/bag_not_ok.svg"
        width="150"
        class="mb4 mt-4"
      />
    </div>
    <div style="margin-top: 40px">
      <p>
        This shop is not taking orders at this time.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "StorefrontDisabledMessage",
  data() {
    return {};
  }
};
</script>
